<template>
  <form id="payment-form" @submit.prevent="handleSubmit">
    <div id="payment-element" class="mb-6" />
    <UButton
      type="submit"
      block
      size="xl"
      color="main"
      :loading="isLoading"
      :disabled="isLoading || !stripe || !elements"
    >
      Payer maintenant
    </UButton>
    <div v-if="errorMessage" class="mt-4 text-red-500 text-sm text-center">
      {{ errorMessage }}
    </div>
  </form>
</template>

<script setup lang="ts">
import { loadStripe } from "@stripe/stripe-js";
import type { Stripe, StripeElements } from "@stripe/stripe-js";

const props = defineProps<{
  clientSecret: string;
}>();

const config = useRuntimeConfig();
const stripe = ref<Stripe | null>(null);
const elements = ref<StripeElements | null>(null);
const isLoading = ref(false);
const errorMessage = ref("");

onMounted(async () => {
  // Replace with your public key from env
  stripe.value = await loadStripe(config.public.stripePublicKey as string);

  if (!stripe.value) {
    console.error("Stripe failed to load");
    return;
  }

  elements.value = stripe.value.elements({
    clientSecret: props.clientSecret,
    appearance: {
      theme: "stripe",
      variables: {
        colorPrimary: "#000000", // Adjust to match your theme
      },
    },
  });

  const paymentElement = elements.value.create("payment");
  paymentElement.mount("#payment-element");
});

const handleSubmit = async () => {
  if (!stripe.value || !elements.value) {
    return;
  }

  isLoading.value = true;
  errorMessage.value = "";

  const { error } = await stripe.value.confirmPayment({
    elements: elements.value,
    confirmParams: {
      // Return URL where the user should be redirected after the payment.
      return_url: `${window.location.origin}/checkout/success`,
    },
  });

  if (error) {
    // This point will only be reached if there is an immediate error when
    // confirming the payment. Show error to your customer.
    errorMessage.value = error.message || "Une erreur est survenue.";
  } else {
    // Your customer will be redirected to your `return_url`. For some payment
    // methods like iDEAL, your customer will be redirected to an intermediate
    // site first to authorize the payment, then redirected to the `return_url`.
  }

  isLoading.value = false;
};
</script>
